'use client';
"use strict";

var _excluded = ["in", "unmountOnExit", "animateOpacity", "startingHeight", "endingHeight", "style", "className", "transition", "transitionEnd"],
    _excluded2 = ["unmountOnExit", "in", "className", "transition", "transitionEnd", "delay"],
    _excluded3 = ["unmountOnExit", "in", "reverse", "initialScale", "className", "transition", "transitionEnd", "delay"],
    _excluded4 = ["direction", "style", "unmountOnExit", "in", "className", "transition", "transitionEnd", "delay", "motionProps"],
    _excluded5 = ["unmountOnExit", "in", "reverse", "className", "offsetX", "offsetY", "transition", "transitionEnd", "delay"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Collapse: function Collapse() {
    return _Collapse;
  },
  EASINGS: function EASINGS() {
    return TRANSITION_EASINGS;
  },
  Fade: function Fade() {
    return _Fade;
  },
  ScaleFade: function ScaleFade() {
    return _ScaleFade;
  },
  Slide: function Slide() {
    return _Slide;
  },
  SlideFade: function SlideFade() {
    return _SlideFade;
  },
  fadeConfig: function fadeConfig() {
    return _fadeConfig;
  },
  getSlideTransition: function getSlideTransition() {
    return _getSlideTransition;
  },
  scaleFadeConfig: function scaleFadeConfig() {
    return _scaleFadeConfig;
  },
  slideFadeConfig: function slideFadeConfig() {
    return _slideFadeConfig;
  },
  withDelay: function withDelay() {
    return _withDelay;
  }
});

module.exports = __toCommonJS(src_exports); // src/collapse.tsx

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_framer_motion = require("framer-motion");

var import_react = require("react"); // src/transition-utils.ts


var TRANSITION_EASINGS = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
};
var TRANSITION_VARIANTS = {
  scale: {
    enter: {
      scale: 1
    },
    exit: {
      scale: 0.95
    }
  },
  fade: {
    enter: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  pushLeft: {
    enter: {
      x: "100%"
    },
    exit: {
      x: "-30%"
    }
  },
  pushRight: {
    enter: {
      x: "-100%"
    },
    exit: {
      x: "30%"
    }
  },
  pushUp: {
    enter: {
      y: "100%"
    },
    exit: {
      y: "-30%"
    }
  },
  pushDown: {
    enter: {
      y: "-100%"
    },
    exit: {
      y: "30%"
    }
  },
  slideLeft: {
    position: {
      left: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "-100%",
      y: 0
    }
  },
  slideRight: {
    position: {
      right: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "100%",
      y: 0
    }
  },
  slideUp: {
    position: {
      top: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "-100%"
    }
  },
  slideDown: {
    position: {
      bottom: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "100%"
    }
  }
};

function _getSlideTransition(options) {
  var _a;

  var side = (_a = options == null ? void 0 : options.direction) != null ? _a : "right";

  switch (side) {
    case "right":
      return TRANSITION_VARIANTS.slideRight;

    case "left":
      return TRANSITION_VARIANTS.slideLeft;

    case "bottom":
      return TRANSITION_VARIANTS.slideDown;

    case "top":
      return TRANSITION_VARIANTS.slideUp;

    default:
      return TRANSITION_VARIANTS.slideRight;
  }
}

var TRANSITION_DEFAULTS = {
  enter: {
    duration: 0.2,
    ease: TRANSITION_EASINGS.easeOut
  },
  exit: {
    duration: 0.1,
    ease: TRANSITION_EASINGS.easeIn
  }
};
var _withDelay = {
  enter: function enter(transition, delay) {
    return _objectSpread(_objectSpread({}, transition), {}, {
      delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
    });
  },
  exit: function exit(transition, delay) {
    return _objectSpread(_objectSpread({}, transition), {}, {
      delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
    });
  }
}; // src/collapse.tsx

var import_jsx_runtime = require("react/jsx-runtime");

var isNumeric = function isNumeric(value) {
  return value != null && parseInt(value.toString(), 10) > 0;
};

var defaultTransitions = {
  exit: {
    height: {
      duration: 0.2,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    }
  },
  enter: {
    height: {
      duration: 0.3,
      ease: TRANSITION_EASINGS.ease
    },
    opacity: {
      duration: 0.4,
      ease: TRANSITION_EASINGS.ease
    }
  }
};
var variants = {
  exit: function exit(_ref) {
    var animateOpacity = _ref.animateOpacity,
        startingHeight = _ref.startingHeight,
        transition = _ref.transition,
        transitionEnd = _ref.transitionEnd,
        delay = _ref.delay;

    var _a;

    return _objectSpread(_objectSpread({}, animateOpacity && {
      opacity: isNumeric(startingHeight) ? 1 : 0
    }), {}, {
      height: startingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : _withDelay.exit(defaultTransitions.exit, delay)
    });
  },
  enter: function enter(_ref2) {
    var animateOpacity = _ref2.animateOpacity,
        endingHeight = _ref2.endingHeight,
        transition = _ref2.transition,
        transitionEnd = _ref2.transitionEnd,
        delay = _ref2.delay;

    var _a;

    return _objectSpread(_objectSpread({}, animateOpacity && {
      opacity: 1
    }), {}, {
      height: endingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : _withDelay.enter(defaultTransitions.enter, delay)
    });
  }
};

var _Collapse = (0, import_react.forwardRef)(function (props, ref) {
  var isOpen = props.in,
      unmountOnExit = props.unmountOnExit,
      _props$animateOpacity = props.animateOpacity,
      animateOpacity = _props$animateOpacity === void 0 ? true : _props$animateOpacity,
      _props$startingHeight = props.startingHeight,
      startingHeight = _props$startingHeight === void 0 ? 0 : _props$startingHeight,
      _props$endingHeight = props.endingHeight,
      endingHeight = _props$endingHeight === void 0 ? "auto" : _props$endingHeight,
      style = props.style,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      rest = _objectWithoutProperties(props, _excluded);

  var _ref3 = (0, import_react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      mounted = _ref4[0],
      setMounted = _ref4[1];

  (0, import_react.useEffect)(function () {
    var timeout = setTimeout(function () {
      setMounted(true);
    });
    return function () {
      return clearTimeout(timeout);
    };
  }, []);
  (0, import_shared_utils.warn)({
    condition: Number(startingHeight) > 0 && !!unmountOnExit,
    message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
  });
  var hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
  var custom = {
    startingHeight: startingHeight,
    endingHeight: endingHeight,
    animateOpacity: animateOpacity,
    transition: !mounted ? {
      enter: {
        duration: 0
      }
    } : transition,
    transitionEnd: {
      enter: transitionEnd == null ? void 0 : transitionEnd.enter,
      exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : _objectSpread(_objectSpread({}, transitionEnd == null ? void 0 : transitionEnd.exit), {}, {
        display: hasStartingHeight ? "block" : "none"
      })
    }
  };
  var show = unmountOnExit ? isOpen : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_framer_motion.AnimatePresence, {
    initial: false,
    custom: custom,
    children: show && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_framer_motion.motion.div, _objectSpread(_objectSpread({
      ref: ref
    }, rest), {}, {
      className: (0, import_shared_utils.cx)("chakra-collapse", className),
      style: _objectSpread({
        overflow: "hidden",
        display: "block"
      }, style),
      custom: custom,
      variants: variants,
      initial: unmountOnExit ? "exit" : false,
      animate: animate,
      exit: "exit"
    }))
  });
});

_Collapse.displayName = "Collapse"; // src/fade.tsx

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_framer_motion2 = require("framer-motion");

var import_react2 = require("react");

var import_jsx_runtime2 = require("react/jsx-runtime");

var variants2 = {
  enter: function enter() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        transition = _ref5.transition,
        transitionEnd = _ref5.transitionEnd,
        delay = _ref5.delay;

    var _a;

    return {
      opacity: 1,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : _withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: function exit() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        transition = _ref6.transition,
        transitionEnd = _ref6.transitionEnd,
        delay = _ref6.delay;

    var _a;

    return {
      opacity: 0,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : _withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  }
};
var _fadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants2
};

var _Fade = (0, import_react2.forwardRef)(function Fade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      rest = _objectWithoutProperties(props, _excluded2);

  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var custom = {
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_framer_motion2.AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_framer_motion2.motion.div, _objectSpread(_objectSpread({
      ref: ref,
      className: (0, import_shared_utils2.cx)("chakra-fade", className),
      custom: custom
    }, _fadeConfig), {}, {
      animate: animate
    }, rest))
  });
});

_Fade.displayName = "Fade"; // src/scale-fade.tsx

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_framer_motion3 = require("framer-motion");

var import_react3 = require("react");

var import_jsx_runtime3 = require("react/jsx-runtime");

var variants3 = {
  exit: function exit(_ref7) {
    var reverse = _ref7.reverse,
        initialScale = _ref7.initialScale,
        transition = _ref7.transition,
        transitionEnd = _ref7.transitionEnd,
        delay = _ref7.delay;

    var _a;

    return _objectSpread(_objectSpread({
      opacity: 0
    }, reverse ? {
      scale: initialScale,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    } : {
      transitionEnd: _objectSpread({
        scale: initialScale
      }, transitionEnd == null ? void 0 : transitionEnd.exit)
    }), {}, {
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : _withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
    });
  },
  enter: function enter(_ref8) {
    var transitionEnd = _ref8.transitionEnd,
        transition = _ref8.transition,
        delay = _ref8.delay;

    var _a;

    return {
      opacity: 1,
      scale: 1,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : _withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var _scaleFadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants3
};

var _ScaleFade = (0, import_react3.forwardRef)(function ScaleFade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      _props$reverse = props.reverse,
      reverse = _props$reverse === void 0 ? true : _props$reverse,
      _props$initialScale = props.initialScale,
      initialScale = _props$initialScale === void 0 ? 0.95 : _props$initialScale,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      rest = _objectWithoutProperties(props, _excluded3);

  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    initialScale: initialScale,
    reverse: reverse,
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_framer_motion3.AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_framer_motion3.motion.div, _objectSpread(_objectSpread({
      ref: ref,
      className: (0, import_shared_utils3.cx)("chakra-offset-slide", className)
    }, _scaleFadeConfig), {}, {
      animate: animate,
      custom: custom
    }, rest))
  });
});

_ScaleFade.displayName = "ScaleFade"; // src/slide.tsx

var import_shared_utils4 = require("@chakra-ui/shared-utils");

var import_framer_motion4 = require("framer-motion");

var import_react4 = require("react");

var import_jsx_runtime4 = require("react/jsx-runtime");

var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: TRANSITION_EASINGS.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants4 = {
  exit: function exit(_ref9) {
    var direction = _ref9.direction,
        transition = _ref9.transition,
        transitionEnd = _ref9.transitionEnd,
        delay = _ref9.delay;

    var _a;

    var _getSlideTransition2 = _getSlideTransition({
      direction: direction
    }),
        exitStyles = _getSlideTransition2.exit;

    return _objectSpread(_objectSpread({}, exitStyles), {}, {
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : _withDelay.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    });
  },
  enter: function enter(_ref10) {
    var direction = _ref10.direction,
        transitionEnd = _ref10.transitionEnd,
        transition = _ref10.transition,
        delay = _ref10.delay;

    var _a;

    var _getSlideTransition3 = _getSlideTransition({
      direction: direction
    }),
        enterStyles = _getSlideTransition3.enter;

    return _objectSpread(_objectSpread({}, enterStyles), {}, {
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : _withDelay.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    });
  }
};

var _Slide = (0, import_react4.forwardRef)(function Slide2(props, ref) {
  var _props$direction = props.direction,
      direction = _props$direction === void 0 ? "right" : _props$direction,
      style = props.style,
      unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      className = props.className,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      motionProps = props.motionProps,
      rest = _objectWithoutProperties(props, _excluded4);

  var transitionStyles = _getSlideTransition({
    direction: direction
  });

  var computedStyle = Object.assign({
    position: "fixed"
  }, transitionStyles.position, style);
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    transitionEnd: transitionEnd,
    transition: transition,
    direction: direction,
    delay: delay
  };
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_framer_motion4.AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_framer_motion4.motion.div, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      initial: "exit",
      className: (0, import_shared_utils4.cx)("chakra-slide", className),
      animate: animate,
      exit: "exit",
      custom: custom,
      variants: variants4,
      style: computedStyle
    }, motionProps))
  });
});

_Slide.displayName = "Slide"; // src/slide-fade.tsx

var import_shared_utils5 = require("@chakra-ui/shared-utils");

var import_framer_motion5 = require("framer-motion");

var import_react5 = require("react");

var import_jsx_runtime5 = require("react/jsx-runtime");

var variants5 = {
  initial: function initial(_ref11) {
    var offsetX = _ref11.offsetX,
        offsetY = _ref11.offsetY,
        transition = _ref11.transition,
        transitionEnd = _ref11.transitionEnd,
        delay = _ref11.delay;

    var _a;

    return {
      opacity: 0,
      x: offsetX,
      y: offsetY,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : _withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: function enter(_ref12) {
    var transition = _ref12.transition,
        transitionEnd = _ref12.transitionEnd,
        delay = _ref12.delay;

    var _a;

    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : _withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: function exit(_ref13) {
    var offsetY = _ref13.offsetY,
        offsetX = _ref13.offsetX,
        transition = _ref13.transition,
        transitionEnd = _ref13.transitionEnd,
        reverse = _ref13.reverse,
        delay = _ref13.delay;

    var _a;

    var offset = {
      x: offsetX,
      y: offsetY
    };
    return _objectSpread({
      opacity: 0,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : _withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
    }, reverse ? _objectSpread(_objectSpread({}, offset), {}, {
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    }) : {
      transitionEnd: _objectSpread(_objectSpread({}, offset), transitionEnd == null ? void 0 : transitionEnd.exit)
    });
  }
};
var _slideFadeConfig = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: variants5
};

var _SlideFade = (0, import_react5.forwardRef)(function SlideFade2(props, ref) {
  var unmountOnExit = props.unmountOnExit,
      isOpen = props.in,
      _props$reverse2 = props.reverse,
      reverse = _props$reverse2 === void 0 ? true : _props$reverse2,
      className = props.className,
      _props$offsetX = props.offsetX,
      offsetX = _props$offsetX === void 0 ? 0 : _props$offsetX,
      _props$offsetY = props.offsetY,
      offsetY = _props$offsetY === void 0 ? 8 : _props$offsetY,
      transition = props.transition,
      transitionEnd = props.transitionEnd,
      delay = props.delay,
      rest = _objectWithoutProperties(props, _excluded5);

  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    offsetX: offsetX,
    offsetY: offsetY,
    reverse: reverse,
    transition: transition,
    transitionEnd: transitionEnd,
    delay: delay
  };
  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_framer_motion5.AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_framer_motion5.motion.div, _objectSpread(_objectSpread({
      ref: ref,
      className: (0, import_shared_utils5.cx)("chakra-offset-slide", className),
      custom: custom
    }, _slideFadeConfig), {}, {
      animate: animate
    }, rest))
  });
});

_SlideFade.displayName = "SlideFade"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  Collapse: _Collapse,
  EASINGS: EASINGS,
  Fade: _Fade,
  ScaleFade: _ScaleFade,
  Slide: _Slide,
  SlideFade: _SlideFade,
  fadeConfig: _fadeConfig,
  getSlideTransition: _getSlideTransition,
  scaleFadeConfig: _scaleFadeConfig,
  slideFadeConfig: _slideFadeConfig,
  withDelay: _withDelay
});